import lrQuery3 from './_src/lrQuery3.vue'

lrQuery3.install = function(Vue) {
  Vue.component(lrQuery3.name, lrQuery3)
}

export default lrQuery3